import React, { useEffect, useState } from 'react';
import './Header.css';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { NotificationsActionHandler } from '../../Redux/Actions/user/NotificationsList';
import { NotificationsReadActionHandler } from '../../Redux/Actions/user/NotificationsRead';
import { NotificationsReadAllActionHandler } from '../../Redux/Actions/user/NotificationsReadAll';
import { UserProfileActionHandler } from '../../Redux/Actions/user/SettingsUserProfile';
import UserList from './ClientsList';
import { Tooltip } from 'antd';
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';

const Header = () => {
    const [showUserList, setShowUserList] = useState(false);
    let dispatch = useDispatch();
    let Navigate = useNavigate();
    const SearchIcon = '/assets/SearchIcon.svg';
    const NotificationIcon = '/assets/notification.svg';
    const profile = '/assets/profile.svg';
    const line = '/assets/Line_11.svg';
    const ClientSwitchLogo = '/assets/Switch.svg';

    const userProfileData = useSelector(
        (state) => state.SettingsUserProfileData?.user_profile_data
    );

    const notificationsData = useSelector(
        (state) => state?.NotificationsData?.notifications_data?.data
    );
    const notificationsReadData = useSelector(
        (state) => state?.NotificationsReadData?.notifications_read_data
    );

    const unreadNotifications =
        notificationsData != undefined
            ? notificationsData.filter((item) => item.read_at === null).length
            : 0;

    const notificationsReadAllData = useSelector(
        (state) => state?.NotificationsReadAllData?.notifications_read_all_data
    );
    const fetchData = async () => {
        try {
            dispatch(NotificationsActionHandler());
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleNotificationsread = (id) => {
        dispatch(NotificationsReadActionHandler(id));
    };
    const handleNotificationsreadAll = () => {
        dispatch(NotificationsReadAllActionHandler());
    };

    useEffect(() => {
        // fetchData();
        dispatch(UserProfileActionHandler());
    }, []);

    useEffect(() => {
        if (notificationsReadAllData) {
            fetchData();
        }
    }, [notificationsReadAllData]);
    useEffect(() => {
        if (notificationsReadData) {
            fetchData();
        }
    }, [notificationsReadData]);

    useEffect(() => {
        if (
            userProfileData?.client_mfa_enabled &&
            !userProfileData?.is_mfa_enabled
        ) {
            console.log('Navigated from Header');
            Navigate('/multi-factor');
        }
    }, [userProfileData]);

    const selectedClientName = localStorage.getItem('client_name');

    return (
        <header className='custom-header'>
            <div className='relative search-container'>
                {/* <input
                    type='text'
                    placeholder='Search here'
                    className='search-input'
                />
                <img src={SearchIcon} alt='' className='search-icon' /> */}
            </div>

            <div className='user-notify'>
                <UserList
                    openModel={showUserList}
                    handleCancel={() => setShowUserList(false)}
                />
                {selectedClientName && (
                    <div>
                        You are viewing{' '}
                        <span className='client__text'>
                            {selectedClientName}
                        </span>{' '}
                        account.
                    </div>
                )}
                {((userProfileData && userProfileData?.client_id == 1) ||
                    selectedClientName) && (
                    <div
                        className='dropup'
                        onClick={() => setShowUserList(true)}>
                        <img
                            src={ClientSwitchLogo}
                            className='dropbtn'
                            alt='ClientSwitchLogo'
                        />
                    </div>
                )}{' '}
                {userProfileData && userProfileData?.subscription ? (
                    <div className='dropup'>
                        <img
                            src={NotificationIcon}
                            className='dropbtn'
                            alt='NotificationIcon'
                        />
                        {unreadNotifications > 0 ? (
                            <span className='button_badge'>
                                {unreadNotifications}
                            </span>
                        ) : (
                            ''
                        )}
                        <div className='dropup-content header-availibility'>
                            <div className='header-text'>
                                <span className='header-notifications-text'>
                                    Notifications
                                </span>
                                <div
                                    className='header-mark-all-read-text'
                                    onClick={() =>
                                        handleNotificationsreadAll()
                                    }>
                                    Mark all as read
                                </div>
                            </div>
                            <div className='separator-header'></div>
                            {notificationsData &&
                                notificationsData
                                    .slice(0, 4)
                                    .map((item, index) => (
                                        <div key={index}>
                                            <div
                                                className={
                                                    item.read_at === null
                                                        ? 'header-aval-inner header-aval-inner-unread'
                                                        : 'header-aval-inner'
                                                }>
                                                <div className='header-notifications-content'>
                                                    <img
                                                        src={NotificationIcon}
                                                        alt='user-avatar'
                                                        height={30}
                                                        width={30}
                                                    />
                                                    <p className='header-notifications-unread'>
                                                        {item.title}
                                                    </p>
                                                </div>
                                                <div className='header-day-view'>
                                                    <span className='header-day-ago'>
                                                        {item.read_at} day ago
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='separator-header'></div>
                                        </div>
                                    ))}
                            <div className='header-view-all'>
                                <Link to={'notifications/'}>View All</Link>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className='dropup'>
                        <Tooltip
                            title='Please pick a plan to use the platform!'
                            placement='bottom'
                            overlayStyle={{ maxWidth: '900px', width: '310px' }}
                            color={'#585858'}>
                            <img
                                src={NotificationIcon}
                                className='dropbtn'
                                alt='NotificationIcon'
                            />
                        </Tooltip>
                    </div>
                )}
                {/* <img src={NotificationIcon} alt="" /> */}
                <img src={line} alt='User' />
                <div className='user-section'>
                    <div className='user-details'>
                        <p>{userProfileData?.first_name}</p>
                        <p>{userProfileData?.role_name}</p>
                    </div>
                    <div className='user-image'>
                        <img
                            className='profile-image-wrapper'
                            src={userProfileData?.profile_picture}
                            alt={userProfileData?.first_name}
                        />
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
